<script>
import BidAmount from "@/components/lot-view/BidAmount.vue"
import BidTotalAmount from "@/components/lot-view/BidTotalAmount.vue"
import CalculatedPremium from "@/components/lot-view/CalculatedPremium.vue"
import TaxRateAndPremiums from "@/components/TaxRateAndPremiums"
import UpcomingAmountPopover from "../../lot-view/UpcomingAmountPopover"
import {mapMutations, mapState} from "vuex";
import logger from "@/logger";
import templatable from "@/mixins/templatable";
import BidAmounts from "@/components/bid-confirmation/BidAmounts.vue";
import LotDetails from "@/components/bid-confirmation/LotDetails.vue";
import {getIncrements} from "@/helpers";

export default {
  name: 'MaxBidForm',
  components: {BidAmount, BidAmounts, LotDetails, BidTotalAmount, CalculatedPremium, TaxRateAndPremiums, UpcomingAmountPopover},
  mixins: [templatable('maxBidModalTemplate')],
  props: {
    lot: {
      required: true,
      type: Object
    },
    value: {
      type: [String, Number],
      required: false
    },
    errorMessage: {},
    maxBidState: {},
    saveUpcomingMaxBidAmount: {}
  },
  computed: {
    ...mapState(['mainConfig']),
    ...mapState({
      upcomingMaxBidPopover: state => state.lotObject.upcomingMaxBidPopover,
    }),
    bidAmount() {
      return parseFloat(this.value || 0)
    },
    nextIncrement() {
      const increments = getIncrements(this.lot);
      return increments[0]?.increment
    }
  },
  data: () => ({
    template: `
      <form ref="maxBidForm" @submit.stop.prevent="submitMaxBid" class="ta-max-bid-form">
        [[template]]
        <b-form-group
            label-for="max-bid-amount"
            :invalid-feedback="errorMessage"
            :state="maxBidState"
            class="ta-lot-bidding-input"
        >
          <b-input-group :prepend="lot.currency.symbol">
            <b-form-input id="max-bid-amount"
                          type="number"
                          :state="maxBidState"
                          :value="value"
                          @input="onInput"
                          @keydown="blockDecimalInput"
                          :placeholder="$t('Your Max Bid')"
                          required
            />
          </b-input-group>
        </b-form-group>
        <upcoming-amount-popover
            target="max-bid-amount"
            :state-object="upcomingMaxBidPopover"
            :text="$t('Current Max bid amount is invalid. Please submit one of the following amounts') + ':'"
            :currency-code="lot.currency.code"
            :as-popover="false"
            @hidePopover="hideUpcomingAmountPopover('upcomingMaxBidPopover')"
            @setNewAmount="saveUpcomingMaxBidAmount"
        />
      </form>
    `
  }),
  methods: {
    ...mapMutations(['hideUpcomingAmountPopover']),
    onInput(value) {
      this.$nextTick(() => {
        value = Math.floor(value || 0)
        this.$emit('input', value)
        this.$emit('input', value)
      })
    },
    blockDecimalInput(event) {
      if (['.', ',', 'e', 'E', '+', '-'].includes(event.key)) {
        event.preventDefault();
      }
    },
    close() {
      this.$emit('close')
    },
    submitMaxBid() {
      this.$emit('submit')
    },
    deleteMaxBid() {
      this.$emit('delete')
    }
  }
}
</script>
